const styles = (theme) => ({
  colorBlue: {
    color: '#235078',
  },
})

export default styles
